import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { getDinnerBookingAllergyInformation } from "state/school_money/selectors";

import AllergiesModal from "components/school_money/dinners/AllergiesModal";

class AllergiesIndicator extends React.Component {
  
  static propTypes = {
    className: PropTypes.string.isRequired
  }
  
  state = {
    isModalOpen: false
  }
  
  openModal = () => {
    this.setState({ isModalOpen: true });
  }
  
  closeModal = () => {
    this.setState({ isModalOpen: false });
  }
  
  render() {
    
    const { className, dinnerBookingID, active } = this.props;
    const { isModalOpen } = this.state;
    
    const classNames = [ className ];
    classNames.push(active ? `${className}--active` : `${className}--inactive`);
    
    return (
      <div>
        <div className={classNames.join(" ")} onClick={active ? this.openModal : undefined}>
          Allergies
        </div>
        <AllergiesModal
          dinnerBookingID={dinnerBookingID}
          isWarning={false}
          isOpen={isModalOpen}
          onClose={this.closeModal}
        />
      </div>
    );
    
  }
  
}

export default connect(
  (state, ownProps) => {
    const allergyInformationList = getDinnerBookingAllergyInformation(state, ownProps.dinnerBookingID);
    const active = allergyInformationList.some(allergyInformation => allergyInformation !== "");
    return { active };
  }
)(AllergiesIndicator);



// WEBPACK FOOTER //
// ./src/components/school_money/dinners/AllergiesIndicator.js